import { APP_COMPANY_CONFIG_LS } from "../../../../_Config/_CompanyLS/AppCompanyConfigLS";

export const BRAND_LS = {
    PREFIX: APP_COMPANY_CONFIG_LS.TEXT.TEXT__FOOTER_BRAND_POWERED_BY,
    NAME: APP_COMPANY_CONFIG_LS.TEXT.TEXT__FOOTER_BRAND_NAME,
    URL: APP_COMPANY_CONFIG_LS.TEXT.TEXT__FOOTER_LINK_REDIRECT,
};

export const BrandLS = () => (

    <div className="LStudio__app_container_loopy_strip">

        <div className="LStudio__app_container_powered_by_container">

            <span className="LStudio__app_content_powered_text">{BRAND_LS.PREFIX}</span>{" "}

            <a
                href={BRAND_LS.URL}
                target="_blank"
                rel="noopener noreferrer"
                className="LStudio__app_content_loopy_brand_link_glow"
            >
                <span className="tech-text-bold">{BRAND_LS.NAME}</span>
            </a>

        </div>

    </div>
);
